import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@app/shared/ui/atoms/Common';

interface TopBarProps {
  url?: string;
  translationKey: string;
}

export function TopBar({ url, translationKey }: TopBarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between py-2.5">
      {url && (
        <Button variant="secondary" size="sm" className="flex w-fit items-center px-2.5" asChild>
          <Link to={url}>{t(translationKey)}</Link>
        </Button>
      )}
    </div>
  );
}
